import {
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";
import PropTypes from "prop-types";
import { useState, useEffect } from "react";

import "@/components/membership/Dashboard/Dashboard.css";
import { getDashboardIcon } from "@/components/membership/Dashboard/DashboardUtils/dashboardIcons";
import Notifications from "@/components/Notifications/Notifications";
import { formatTimestamp } from "@/utils/util";

function VANModal({ row }) {
  const [open, setOpen] = useState(false);
  const [showVANData, setShowVANData] = useState(false);
  const [tableRows, setTableRows] = useState([]);
  const [file, setFile] = useState(row);
  const [notification, setNotification] = useState({});

  useEffect(() => {
    setFile(row);
    setShowVANData(row.VAN?.job_id);
  }, [row]);

  useEffect(() => {
    if (file.VAN) {
      createTable();
    }
    // createTable is an inline function recreated every render; depending
    // on it would cause infinite re-runs.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [file]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const createData = (fieldName, value) => {
    return { fieldName, value };
  };

  const createTable = () => {
    const rows = [
      createData("Job Id:", file.VAN.job_id),
      createData("Submitted to VAN:", formatTimestamp(file.VAN.sent, true)),
      createData("Posted to VAN:", formatTimestamp(file.VAN.posted, true)),
    ];
    setTableRows(rows);
  };

  return (
    <>
      {getDashboardIcon(file, "VAN", handleClickOpen)}
      <Dialog onClose={handleClose} open={open} data-testid="van-modal">
        <>
          <DialogTitle className="seiu-modal-header">VAN Summary</DialogTitle>
          <DialogContent dividers>
            {showVANData ? (
              <>
                <TableContainer>
                  <Table sx={{ minWidth: 550 }} aria-label="simple table">
                    <TableBody>
                      {tableRows.map((row) => (
                        <TableRow
                          key={row.fieldName}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <TableCell
                            component="th"
                            scope="row"
                            sx={{ color: "#000000a6" }}
                          >
                            {row.fieldName}
                          </TableCell>
                          <TableCell align="right" sx={{ fontWeight: 400 }}>
                            {row.value}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </>
            ) : (
              <Box>
                <Typography sx={{ fontStyle: "italic" }}>
                  No summary available for this file
                </Typography>
              </Box>
            )}
          </DialogContent>
          <DialogActions>
            <Button
              // Focus the safe (Close) button on open
              // eslint-disable-next-line jsx-a11y/no-autofocus
              autoFocus
              className="siteBlueOutlined"
              onClick={handleClose}
            >
              Close
            </Button>
          </DialogActions>
        </>
      </Dialog>

      {!!Object.keys(notification).length && (
        <Notifications
          notification={notification}
          setNotification={setNotification}
        />
      )}
    </>
  );
}

VANModal.propTypes = {
  row: PropTypes.object,
};

export default VANModal;
